const newRelicDummyAgent = {
  noticeError: (error) => console.error(error),
};

export function getNewRelicAgent() {
  return window.newrelic || newRelicDummyAgent;
}
